import { AbstractControl } from "@angular/forms";

export function currentBalanceValidator(control: AbstractControl) {
    let currentBalance = control.value.replace(/[^0-9.]/g, '');
    console.log(typeof(currentBalance), "curBalance");
    if (currentBalance==''||Number(currentBalance)<1) {
        return {invalidAmount:true}
    }
    return null;
}